import { createContext } from 'react'

import { AmazonPageContextType } from './types'

export const AmazonPageContext = createContext<AmazonPageContextType>({} as AmazonPageContextType)
